import { render, staticRenderFns } from "./ManageDoctorPage.vue?vue&type=template&id=295c3d3c&"
import script from "./ManageDoctorPage.vue?vue&type=script&lang=js&"
export * from "./ManageDoctorPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports